module.exports = __webpack_public_path__ + "img/1-2.5c9ec09e.png";